export const CUSTOM_LAYOUT_PATH = ["/app/studio", "/app/preview","/app/videobook-builder", "/app/videobook-slides"];

export const HEADER_LAYOUT = ["/app/scenes"];
